import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const VIEWER_ALLOWED = ['/extrato', '/perfil'];

export default function PrivateRoute({ children }) {
  const { usuario, loading, isViewer } = useAuth();
  const { pathname } = useLocation();

  if (loading) return (
    <div className="loading-wrap" style={{ minHeight: '100vh' }}>
      <div className="spinner" />
    </div>
  );

  if (!usuario) return <Navigate to="/login" replace />;

  if (isViewer && !VIEWER_ALLOWED.includes(pathname)) {
    return <Navigate to="/extrato" replace />;
  }

  return children;
}
